import { useEffect, useState } from "react";
import { useField } from "formik";

import { getAllUsers } from "../../services/users";

import CardFSFB from "../../atoms/Card";
import { TitleAccordion } from "../TitleAccordion";
import SelectOption from "../../atoms/SelectOption";

import styles from "../MonitoringList/MonitoringList.module.scss";

export const MonitoringResponsible = ({ ...props }) => {
  const [field] = useField({ ...props });
  const [responsiblesOptions, setResponsiblesOptions] = useState([]);

  const [isActive, setIsActive] = useState(true);

  const getResponsibles = async () => {
    try {
      const { response = [] } = await getAllUsers();
      if (!response.length) setResponsiblesOptions([])
      else setResponsiblesOptions(response);
    } catch (error) {
      console.error(error);
      setResponsiblesOptions([]);
    }
  };

  useEffect(() => {
    getResponsibles();
  }, []);

  return (
    <CardFSFB>
      <section className={styles.cardContainer}>
        <TitleAccordion
          handleClick={() => setIsActive(!isActive)}
          isActive={isActive}
        >
          <h2 className={styles.titleCard}> 3. Profesional de salud a cargo </h2>
        </TitleAccordion>
        {isActive ? (
          <div className={styles.selectOption} style={{ marginBottom: "16px" }}>
            <SelectOption {...field}>
              <option value="" disabled selected>
                Selecciona el nombre del profesional de la salud
              </option>
              {responsiblesOptions.map(({ id, name }) => (
                <option value={id} key={id}>
                  {name}
                </option>
              ))}
            </SelectOption>
          </div>
        ) : null}
      </section>
    </CardFSFB>
  );
};
